import { Navigate, useNavigate } from 'react-router'
import { useChamada } from '../features/office/chamada.tsx'
import { ReuniaoCelular } from '../features/office/ReuniaoCelular.tsx'
import { ReuniaoDaSala } from '../features/office/ReuniaoDaSala.tsx'
import { useCompacto } from '../shell/compacto.ts'
import '../features/office/chamada.css'

/**
 * A reunião de uma sala do Escritório dentro do Orbind (SPEC-20261010-1557):
 * o rail com os apps continua à esquerda. Sem chamada em andamento, volta ao
 * tabuleiro.
 */
/** Fundo da reunião no visual que a pessoa escolheu no Escritório (SPEC-20261010-2248). */
function cenarioDa(modelo: string) {
  let visual: string | null = null
  try {
    visual = localStorage.getItem('orbind.escritorio.visual')
  } catch {
    // sem armazenamento: fica o pixel art
  }
  return visual === 'realista' ? `/escritorio/realista/fundos/${modelo}.jpg?v=1` : `/escritorio/fundos/${modelo}.jpg?v=2`
}

export function ReuniaoDoEscritorioPage() {
  const ch = useChamada()
  const navegar = useNavigate()
  const celular = useCompacto()
  if (!ch?.sala) return <Navigate to="/office" replace />
  // no celular a reunião ocupa a tela inteira, no jeito do Meet de celular (SPEC-20261011-0330)
  if (celular)
    return (
      <ReuniaoCelular
        cenario={cenarioDa(ch.sala.template)}
        onVoltar={() => navegar('/office')}
        onSair={() => {
          ch.sair()
          navegar('/office')
        }}
      />
    )
  return (
    <div className="reuniao-pagina">
      <ReuniaoDaSala
        cenario={cenarioDa(ch.sala.template)}
        onVoltar={() => navegar('/office')}
        onSair={() => {
          ch.sair()
          navegar('/office')
        }}
      />
    </div>
  )
}
